/*** IMPORTS FROM imports-loader ***/
var _ = require("tpl-shim/fake-lodash.js");

export default function(data) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div class="thumbnail-col thumbnail-wrapper">\n  ';
 if(data.model.isSpecialFolder()) { ;
__p += '\n    <img class="folder-img" src="https://d3jozdooylvm2p.cloudfront.net/images/icons/media-folder_purp.png"/>\n  ';
 } else { ;
__p += '\n    <img class="folder-img" src="https://d3jozdooylvm2p.cloudfront.net/images/icons/media-folder_blue.png"/>\n  ';
 } ;
__p += '\n</div>\n\n<div class="filename-col item-cell item-filename">\n  ' +
__e(data.model.get('name')) +
'\n</div>\n\n<div class="type-col item-cell">\n  Folder\n</div>\n\n<div class="uploaded-by-col item-cell"></div>\n<div class="last-modified-col item-cell"></div>\n';
return __p
}
